import React from 'react';

type KybProcess = {
  countryCode: string;
  merchantId: string;
  processId: number;
  isImportedMerchant?: boolean;
};

export const KybProcessContext = React.createContext<KybProcess>({
  countryCode: '',
  merchantId: '',
  processId: 0,
  isImportedMerchant: false,
});
